import { useEffect, useState } from "react";
import { useDonate } from "./DonateModal";

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "services", label: "Services" },
  { id: "events", label: "Events" },
  { id: "contact", label: "Contact Us" },
];

export const Nav = () => {
  const [solid, setSolid] = useState(false);
  const [active, setActive] = useState("home");
  const [open, setOpen] = useState(false);
  const openDonate = useDonate();

  useEffect(() => {
    const onScroll = () => {
      setSolid(window.scrollY > 40);
      let cur = "home";
      NAV_LINKS.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top < window.innerHeight * 0.4) cur = id;
      });
      setActive(cur);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <header className={`nav ${solid || open ? "solid" : ""}`} data-testid="site-nav">
      <div className="wrap nav-in">
        <a className="brand" href="#home" aria-label="Davis Infinite Care Corporation home" data-testid="nav-brand">
          <img src="/assets/logo-dark.jpg" alt="" width="353" height="362" />
          <span>Davis Infinite Care<small>CORPORATION</small></span>
        </a>
        <button
          className="menu-btn"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="links"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-button"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            {open ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>
        <ul className={`links ${open ? "open" : ""}`} id="links" onClick={(e) => e.target.closest("a,button") && setOpen(false)} data-testid="nav-links">
          {NAV_LINKS.map(({ id, label }) => (
            <li key={id}>
              <a href={`#${id}`} className={active === id ? "active" : ""} data-testid={`nav-link-${id}`}>{label}</a>
            </li>
          ))}
          <li>
            <button type="button" className="btn btn-gold" onClick={openDonate} data-testid="nav-donate-button">Donate</button>
          </li>
        </ul>
      </div>
    </header>
  );
};
